// extracted by mini-css-extract-plugin
module.exports = {"c-toggle":"Toggle_c-toggle__o_iur"};